/**
 * VowPath 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'

export const vowpathPaymentConfig: BrandPaymentConfig = {
  brand: 'vowpath',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/vowpath/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/vowpath/vip_bg.webp',
      vipBgColor: '#100f17',
      memberSubscribeBg: '',
      memberSubscribeBgColor: '#231934',
      vipIcon: '/images/vowpath/vip_icon2.png',
      vipDiscountIcon: '/images/vowpath/vip_discount.png',
      discountBg: '/images/vowpath/discount.avif',
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
      purpleTextGradient: 'linear-gradient(109deg, #472D77 0%, #643867 100%)',
      subscribeText1: 'linear-gradient(90deg, #9C5EF9 1%, #F86BCD 34%, #FDB547 65%, #FFE2A4 100%)',
      subscribeText2: '#FFDD97',
      subscribeText3: '#B59C7D',
      subscribeText4: '#FFDD97',
    },
  },

  // 阅读器弹窗配置（沿用 rocnovel 的配置风格）
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #FFA81E, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF8F5',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(109deg, #472D77 0%, #643867 100%)',
      pinkGradient: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
      memberSubscribeBg: '/images/vowpath/chapter/member_subscribe_bg.webp',
    },
  },
}
